import { Component, Input, OnInit } from '@angular/core';
import { DatatableComponent } from '@app/datatables/models/custom-datatable-extension';
import { DatatableComponentDefinition } from '@app/datatables/models/datatable-component-definition.interface';

const options = {
  selector: 'portal-check-column',
  templateUrl: './check-column.component.html',
};

@Component({
  selector: 'portal-check-column',
  templateUrl: './check-column.component.html',
  standalone: false,
})
export class CheckColumnComponent extends DatatableComponent implements OnInit {
  @Input()
  public entry: any = {};

  get isChecked(): boolean {
    return this.datatablePage.isChecked(this.entry);
  }

  ngOnInit(): void {}
}

export const DatatableCheckColumnDefinition: DatatableComponentDefinition = {
  inputParameters: ['entry'],
  render: (data, type) => {
    let result = data;

    if (type === 'display') {
      result = `<${options.selector}></${options.selector}>`;
    }

    return result;
  },
  selector: options.selector,
  type: CheckColumnComponent,
};
